/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ActionIcon,
  ActionIcon$inboundSchema,
  ActionIcon$Outbound,
  ActionIcon$outboundSchema,
} from "./actionicon.js";
import {
  Actions,
  Actions$inboundSchema,
  Actions$Outbound,
  Actions$outboundSchema,
} from "./actions.js";

/**
 * A single option for a dropdown action.
 */
export type DropdownOption = {
  /**
   * Actions to take
   */
  actions?: Actions | undefined;
  /**
   * The config of the action icon.
   */
  icon?: ActionIcon | undefined;
  /**
   * The label of the option.
   */
  label: string;
  /**
   * The value of the option.
   */
  value: string;
};

/** @internal */
export const DropdownOption$inboundSchema: z.ZodType<
  DropdownOption,
  z.ZodTypeDef,
  unknown
> = z.object({
  actions: types.optional(Actions$inboundSchema),
  icon: types.optional(ActionIcon$inboundSchema),
  label: types.string(),
  value: types.string(),
});
/** @internal */
export type DropdownOption$Outbound = {
  actions?: Actions$Outbound | undefined;
  icon?: ActionIcon$Outbound | undefined;
  label: string;
  value: string;
};

/** @internal */
export const DropdownOption$outboundSchema: z.ZodType<
  DropdownOption$Outbound,
  z.ZodTypeDef,
  DropdownOption
> = z.object({
  actions: Actions$outboundSchema.optional(),
  icon: ActionIcon$outboundSchema.optional(),
  label: z.string(),
  value: z.string(),
});

export function dropdownOptionToJSON(dropdownOption: DropdownOption): string {
  return JSON.stringify(DropdownOption$outboundSchema.parse(dropdownOption));
}
export function dropdownOptionFromJSON(
  jsonString: string,
): SafeParseResult<DropdownOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DropdownOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DropdownOption' from JSON`,
  );
}
